import React from "react"
import { Helmet } from "react-helmet"
import { ImageField } from "../../../carlsberg-headless/types/fields/Image"

export interface FaviconProps {
  favicon: ImageField
}

const Favicon: React.FC<FaviconProps> = ({ favicon }) => {
  if (!favicon?.fullUrl) return null

  return (
    <Helmet>
      <link
        rel="icon"
        href={`${favicon?.fullUrl}?width=16&height=16`}
        type={`image/${favicon?.extension}`}
        sizes="16x16"
      />
      <link
        rel="icon"
        href={`${favicon?.fullUrl}?width=32&height=32`}
        type={`image/${favicon?.extension}`}
        sizes="32x32"
      />
      <link
        rel="icon"
        sizes="96x96"
        href={`${favicon?.fullUrl}?width=96&height=96`}
        type={`image/${favicon?.extension}`}
      />
      <link
        rel="icon"
        sizes="192x192"
        href={`${favicon?.fullUrl}?width=192&height=192`}
        type={`image/${favicon?.extension}`}
      />
      <link
        rel="apple-touch-icon"
        sizes="57x57"
        href={`${favicon?.fullUrl}?width=57&height=57`}
      />
      <link
        rel="apple-touch-icon"
        sizes="60x60"
        href={`${favicon?.fullUrl}?width=160height=60`}
      />
      <link
        rel="apple-touch-icon"
        sizes="72x72"
        href={`${favicon?.fullUrl}?width=72&height=72`}
      />
      <link
        rel="apple-touch-icon"
        sizes="76x76"
        href={`${favicon?.fullUrl}?width=76&height=76`}
      />
      <link
        rel="apple-touch-icon"
        sizes="114x114"
        href={`${favicon?.fullUrl}?width=114&height=114`}
      />
      <link
        rel="apple-touch-icon"
        sizes="120x120"
        href={`${favicon?.fullUrl}?width=120&height=120`}
      />
      <link
        rel="apple-touch-icon"
        sizes="144x144"
        href={`${favicon?.fullUrl}?width=144&height=144`}
      />
      <link
        rel="apple-touch-icon"
        sizes="152x152"
        href={`${favicon?.fullUrl}?width=152&height=152`}
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={`${favicon?.fullUrl}?width=180&height=180`}
      />
    </Helmet>
  )
}

export { Favicon }
